import classNames from 'classnames'
import { ReactNode } from 'react'

import { PageSubtitle } from '@apps-common/components/common/portal-title'
import { VertSpacerMd } from '@apps-common/components/layout'

interface IProps {
  subtitleClasses?: string
  subtitle?: string
  titleClasses?: string
  title?: string
  titleIcon?: any
  actions?: any[]
  children?: ReactNode
}

export const ModalHeader: React.FC<IProps> = ({ subtitleClasses, subtitle, titleClasses, title, titleIcon, actions, children }) => (
  <>
    <PageSubtitle>
      <div className='flex items-center justify-between text-text'>
        <div className={classNames('inline-block overflow-hidden', !actions && 'grow')}>
          {subtitle && (
            <div
              className={classNames(
                subtitleClasses,
                'text-[0.7em] leading-[0.7em] jost-medium items-center justify-start text-text-muted rounded-3xl pt-[5px] w-fit',
                title && 'mb-[10px]'
              )}
            >
              {subtitle}
            </div>
          )}
          {!subtitle && (
            <div
              className={classNames(
                subtitleClasses,
                'text-[0.7em] leading-[0.7em] jost items-center justify-start rounded-3xl px-[7px] pt-[5px] w-fit'
              )}
            />
          )}
          {title && (
            <div
              className={classNames(
                titleClasses,
                'jost-light text-[1em] leading-[1.2em] pl-[0px] text-nowrap text-ellipsis overflow-hidden flex items-center justify-between'
              )}
            >
              {title}
              {titleIcon}
            </div>
          )}
        </div>
        {actions && <div className='relative'>{actions}</div>}
      </div>
    </PageSubtitle>
    {children && (
      <div>
        <VertSpacerMd />
        <div>{children}</div>
      </div>
    )}
  </>
)
